import { PlayerValidator, MapValidator } from '@colonist/game-mechanic-validators';
import { GameModeDataController } from '@colonist/shared-types';
export class GameClientState {
    initGameModeData(modeSetting) {
        const gameModeData = GameModeDataController.getModeDataForMode(modeSetting);
        if (gameModeData == undefined) return;
        this.gameModeData = gameModeData;
    }
    initPlayerControllerStates(newPlayerState, userState) {
        const newPlayerController = new PlayerValidator(newPlayerState, userState);
        this.players.push(newPlayerController);
    }
    initMapState(mapState) {
        this.mapState = mapState;
    }
    hasOnlyOneHumanPlayer() {
        let humanPlayers = 0;
        for (const player of this.players){
            if (player.isUser) humanPlayers += 1;
        }
        if (humanPlayers == 1) return true;
        return false;
    }
    constructor(){
        this.players = [];
        this.mapState = new MapValidator({
            tileHexStates: {},
            tileCornerStates: {},
            tileEdgeStates: {},
            portEdgeStates: {},
            fogTileGroupStates: {}
        });
        this.isPlayerTakingOffTurnAction = false;
        this.canResign = false;
        this.isGameOver = false;
    }
}
